<script lang="ts">
    
    import { Badge, Icon, ListGroup, ListGroupItem } from "sveltestrap";
    import type { FormMember } from "../global";
    import UserName from "./UserName.svelte";

    export let members: FormMember[];

    let orderedMembers: FormMember[] = [];
    let partner = false;

    $: orderMembers(members);

    function orderMembers(members: FormMember[]): void {
        partner = members.some(member => member.buddyId);

        orderedMembers = [...members];
        orderedMembers.sort((a, b) => {
            if (a.isOwner) return -1;
            if (b.isOwner) return 1;
            return 0;
        });
    }

</script>

<ListGroup>
    {#if partner}
        <p>En el siguiente listado pueden ver el responsable BuddyPartner (<Icon class="text-warning" name="shield-lock-fill" />) asignado: </p>     
    {/if}

    {#each orderedMembers as member}
    <ListGroupItem>
        <span class:fw-bold={member.isOwner}>
            <Icon name={member.isOwner ? "person-circle" : "person-fill"} />
            <UserName userId={member.userId} />
        </span>
        {#if member.buddyId}
            <Badge pill color="warning">
                <Icon name="shield-lock-fill" />
                <UserName userId={member.buddyId} />
            </Badge>
        {/if}

        {#if member.isSigned}
        <i class="float-end text-success"><Icon name="patch-check" /> Firmado</i>
        {/if}
    </ListGroupItem>
    {/each}
</ListGroup>
